export const ACCOUNTS_SERVICE = 'accounts';
export const ACCOUNTS_SERVICE_API_VERSION = 'v1';

export const BASE_SERVICE = 'base';
export const BASE_SERVICE_API_VERSION = 'v1';

export const INSTITUTE_SERVICE = 'institutes';
export const INSTITUTE_SERVICE_API_VERSION = 'v1';

export const NOTIFICATIONS_SERVICE = 'notifications';
export const NOTIFICATIONS_SERVICE_API_VERSION = 'v1';

export const ADMISSIONS_SERVICE = 'admissions';
export const ADMISSIONS_SERVICE_API_VERSION = 'v1';

export const PAYMENTS_SERVICE = 'payments';
export const PAYMENTS_SERVICE_API_VERSION = 'v1';

export const STUDENTS_SERVICE = 'students';
export const STUDENTS_SERVICE_API_VERSION = 'v1';

export const ATTENDANCES_SERVICE = 'attendances';
export const ATTENDANCES_SERVICE_API_VERSION = 'v1';

export const EMPLOYEES_SERVICE = 'employees';
export const EMPLOYEES_SERVICE_API_VERSION = 'v1';

export const TRANSPORTATIONS_SERVICE = 'transportations';
export const TRANSPORTATIONS_SERVICE_API_VERSION = 'v1';
